class ExceptionData {

	code: string;

	message: string;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}

class ExceptionResponse {

	data: ExceptionData;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}

export default class Exception {

	code: string;

	response: ExceptionResponse;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}